import React from "react";
import { GrantDto } from "../../../../dtos/GrantDto";
import { PhaseDto } from "../../../../dtos/PhaseDto";
import { StepDto } from "../../../../dtos/StepDto";
import { TasksFeatureFlags } from "../../Types";
import { TasklistMode } from "../context/TaskListContext";
import { TasksView } from "./components/TasksView";
import { useTasksController } from "./hooks/useTasksController";

export interface ITasksProps {
    grantData: GrantDto;
    selectedStep?: StepDto | null;  // deprecated: now read from context
    selectedPhase?: PhaseDto | null;  // deprecated: now read from context
    phasesInfo: { getData: () => Promise<PhaseDto | null> }[];
    deepLinkHash: string | null;
    featureOverrides?: Partial<TasksFeatureFlags>;
    // Lets a caller outside the tasklist open a phase summary (the phase header does this from its
    // name). Bump the token to reopen for the same phase.
    requestedSummaryPhase?: { phase: PhaseDto; token: number } | null;
    // True when the caller renders its own always-visible phase header showing the phase name, so
    // the tasklist toolbar must not repeat it. Set by the DC module, which headers every phase.
    nameShownExternally?: boolean;
    // The phase as the page around the tasklist already holds it. DC reloads every phase in the
    // module after an upload, because a rule can complete a task other than the one the file landed
    // in; handing that copy in lets this tasklist show the new status without fetching it again.
    externalPhase?: PhaseDto | null;
}

function Tasks(props: ITasksProps) {
    const ctrl = useTasksController(props);
    return <TasksView {...ctrl} />;
}

export default React.memo(Tasks, (prevProps, nextProps) => {
    return (
        prevProps.grantData === nextProps.grantData &&
        prevProps.phasesInfo === nextProps.phasesInfo &&
        prevProps.deepLinkHash === nextProps.deepLinkHash &&
        prevProps.featureOverrides === nextProps.featureOverrides &&
        prevProps.nameShownExternally === nextProps.nameShownExternally &&
        prevProps.externalPhase === nextProps.externalPhase &&
        prevProps.requestedSummaryPhase?.token === nextProps.requestedSummaryPhase?.token
    );
});
